import { useEffect, useRef, useState } from "react";
import ClientFeed from "../../../components/ClientFeed/Feed/Feed";
import ClientMatches from "../../../components/ClientFeed/ClientMatches/ClientMatches";
import { useSearchParams } from "react-router-dom";
import { jobApplicants } from "../../../services/clientCalls";
import Breadcrumb from "../../../components/UI/Breadcrumb/Breadcrumb";
import TalentsToolbar from "./components/TalentsToolbar";
import TalentsHero from "./components/TalentsHero";

const Feed = () => {
  const [state, setState] = useState("feed");
  const [param] = useSearchParams();
  const [matchCancelled, setMatchCancelled] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [isCancelMatchBtn, setIsCancelMatchBtn] = useState(false);
  const [showCancelMatchModal, setCancelShowModal] = useState(false);
  const [refine, setRefine] = useState(false);
  const [filters, setFilters] = useState({
    role: "",
    skills: "",
    location: "",
    paymentMin: "",
    paymentMax: "",
    jobTypes: "",
    workModes: "",
    // advancedFilters: true,
  });

  useEffect(() => {
    if (param.get("tab") === "matches") {
      setState("matches");
    }
    if (param.get("tab") === "shortlist") {
      setState("shortlist");
    }
  }, [param]);

  const checkMatchCancelled = async () => {
    try {
      const res = await jobApplicants();
      if (res?.data?.data?.message) {
        setMatchCancelled(true);
      } else {
        setMatchCancelled(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    checkMatchCancelled();
  }, []);

  const toolbarRef = useRef(null);

  // ── Refine toggle ──
  const handleRefineToggle = (e) => {
    setFilters((prev) => ({
      ...prev,
      completedPsychometrics: !refine,
    }));
    setRefine((prev) => !prev);
  };

  return (
    <div>
      <Breadcrumb
        crumbs={[
          { label: "Dashboard", href: "/client-activity-summary" },
          { label: "Talents" },
        ]}
        title="Talents"
      />
      <TalentsHero />

      <div ref={toolbarRef}>
        <TalentsToolbar
          activeTab={state}
          onTabChange={setState}
          counts={0}
          refine={refine}
          onRefineToggle={handleRefineToggle}
          onOpenAdvanced={() => setIsSearchModalOpen(true)}
          setCancelShowModal={setCancelShowModal}
        />
      </div>

      {/* {tab !== 'matches' && (
        <ActiveFilterChips filters={filters} refine={refine} onRemove={handleRemoveFilter} onClearAll={handleClearAll} />
      )} */}

      {/* {matchCancelled && (
        <div className={classes.matchWrapper}>
          <p className={classes.matchText}>
            You can match with a talent for free!
          </p>
          <img src={Matches} alt="Matches" className={classes.matchIcon} />
        </div>
      )} */}

      <>
        {state === "feed" && (
          <ClientFeed
            isSearchModalOpen={isSearchModalOpen}
            setIsSearchModalOpen={setIsSearchModalOpen}
            matchCancelled={matchCancelled}
            filters={filters}
            setFilters={setFilters}
            refine={refine}
          />
        )}
        {state === "matches" && (
          <ClientMatches
            setTab={setState}
            setMatchCancelled={setMatchCancelled}
            setCancelShowModal={setCancelShowModal}
            showCancelMatchModal={showCancelMatchModal}
            setIsCancelMatchBtn={setIsCancelMatchBtn}
          />
        )}
        {state === "shortlist" && (
          <ClientFeed
            isSearchModalOpen={isSearchModalOpen}
            setIsSearchModalOpen={setIsSearchModalOpen}
            isShortlist={true}
            matchCancelled={matchCancelled}
          />
        )}
      </>
    </div>
  );
};

export default Feed;
